// extracted by mini-css-extract-plugin
export default {"sideNavRoot":"SideNavigation_sideNavRoot__7ct0c","sideNavExpanded":"SideNavigation_sideNavExpanded__TEfYw","iconButtonRoot":"SideNavigation_iconButtonRoot__fBLBE"};